import * as React from 'react'
import {Alert, Checkbox, Col, DatePicker, Form, Icon, Input, Modal, notification, Row, Spin} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {withTranslation, WithTranslation} from 'react-i18next';
import {NewProjectItem, NewProjectStore, ProjectItem} from 'src/stores/projects-store';
import {connect} from 'redux-scaffolding-ts'
import {nameof} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import {formatMessage} from '../../../core/services/http.service';
import EditableTooltip from '../../../components/editable-tooltip/tooltip';
import moment from 'moment-timezone';
import {Moment} from 'moment';
import LabelIcon from '../../../components/editable-tooltip/label-icon';

let FormItem = Form.Item;
let { RangePicker } = DatePicker;

interface NewProjectViewProps {
    companyId: string,
    onClose: (id: string | undefined, item?: NewProjectItem) => void;
    onOk?: (id: string | undefined) => void,
    firstTaskOptional: boolean,
    companyAllowCir: boolean,
    companyAllowCii: boolean,
    dataProject: any
    onRefresh?: () => void
}

interface NewProjectViewState {
    restrictProjectFields: boolean
    isBusy?: boolean
}

interface ClassFormBodyProps extends WithTranslation {
    item: NewProjectItem | undefined;
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    firstTaskOptional: boolean;
    restrictProjectFields?: boolean;
    companyAllowCir: boolean,
    companyAllowCii: boolean,
}

interface ClassFormBodyState {
    startDate?: Moment
    endDate?: Moment | null
    isSelectingDate?: boolean
    addFirstTask: boolean
}

class ProjectFormBody extends React.Component<ClassFormBodyProps, ClassFormBodyState> {
    constructor(props: ClassFormBodyProps) {
        super(props);
        this.state = {
            addFirstTask: false
        }
    }

    @autobind
    private onOpenCalendar(status: boolean) {
        if (status)
            this.setState({
                isSelectingDate: status
            })
        else
            this.setState({
                isSelectingDate: undefined
            })
    }

    @autobind
    private onSelectStartDate(date: Moment | null) {
        let selectedDate = date ? date.startOf("day").utc() : undefined
        this.setState({
            startDate: selectedDate
        })
    }

    @autobind
    private onSelectEndDate(date: Moment | null) {
        let selectedDate = date ? date.startOf("day").utc() : undefined
        this.setState({
            endDate: selectedDate
        })
    }

    @autobind
    private disabledStartDate(date: Moment | null) {
        if (!date || !this.state.endDate)
            return false
        return date.startOf("day").utc() >= (this.state.endDate ?? moment().utc())
    }

    @autobind
    private disabledEndDate(date: Moment | null) {
        if (!date)
            return false
        return date.startOf("day").utc() <= (this.state.startDate ?? moment().utc())
    }

    @autobind
    private async validateEndDate(rule: any, value: any) {
        if (value != undefined) {
            let endDate = (value as Moment).startOf("day").utc()
            let startDate = this.state.startDate ?? moment.utc().startOf("day")
            if (startDate.unix() > endDate.unix()) {
                throw new Error("End date must be bigger than start date")
            }
        }
    }

    render() {
        const { t } = this.props;
        var item = this.props.item || {} as NewProjectItem;
        return <Form id="modaForm" onKeyUp={(e) => { if (e.keyCode === 13 && this.props.onSave) { this.props.onSave(); } }} onSubmit={() => { if (this.props.onSave) { this.props.onSave(); } }}>
            <Row gutter={24}>
                <Col span={24}>
                    <FormItem label={t("Name")}>
                        {this.props.getFieldDecorator(nameof<NewProjectItem>('title'), {
                            initialValue: item.title,
                            rules: [{ required: true, message: t('Title required') },
                                { max: 255, message: t('Maximum length is 255 characters') },
                            { whitespace: true, message: t('Title required') }],
                        })(
                            <Input placeholder={t("Title")} type="text" disabled={this.props.restrictProjectFields} maxLength={255}/>
                        )}
                    </FormItem>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <FormItem label={t("Code")}>
                {this.props.getFieldDecorator(nameof<NewProjectItem>('code'), {
                  initialValue: item.code,
                  rules: [{ max: 255, message: t('Maximum length is 255 characters') }],
                })(
                  <Input placeholder={t("Code")} type="text" disabled={this.props.restrictProjectFields} maxLength={255} />
                )}
              </FormItem>
            </Col>
                <Col span={12}><EditableTooltip name='project-reference' noIcon>
                    <FormItem label={(
                        <LabelIcon>
                            { t("Reference")}
                        </LabelIcon>
                    )}>
                        {this.props.getFieldDecorator(nameof<NewProjectItem>('reference'), {
                            initialValue: item.reference,
                            rules: [{ required: false, message: t('Reference required') }],
                        })(
                            <Input placeholder={t("Optional reference")} type="text" disabled={this.props.restrictProjectFields}/>
                        )}
                    </FormItem></EditableTooltip>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={24}>
                    <EditableTooltip name='project-is-private' noIcon>
                        <FormItem>
                            {this.props.getFieldDecorator(nameof<NewProjectItem>('isPrivate'), {
                                rules: [], initialValue: item.isPrivate, valuePropName: 'checked'
                            })(
                                <Checkbox disabled={this.props.restrictProjectFields}><span>{t("Project is private")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }}/></Checkbox>
                            )}
                            <small style={{ display: 'block', marginLeft: 25, marginTop: -7, lineHeight: 1.5 }}>{t("Private projects are seen only by project members. Public projects in other hand, can be seen and used by anyone.")}</small>
                        </FormItem>
                    </EditableTooltip>
                </Col>
            </Row>

            {
                !this.props.firstTaskOptional &&
                < Row gutter={24}>
                    <Col span={12}>
                        <FormItem>
                            {this.props.getFieldDecorator(nameof<NewProjectItem>('rdTaxRelief'), {
                                rules: [], initialValue: item.rdTaxRelief, valuePropName: 'checked'
                            })(
                                <Checkbox disabled={this.props.restrictProjectFields || !this.props.companyAllowCir}><span>{t("R&D Tax relief?")}</span></Checkbox>
                            )}

                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem>
                            {this.props.getFieldDecorator(nameof<NewProjectItem>('tiTaxRelief'), {
                                rules: [], initialValue: item.tiTaxRelief, valuePropName: 'checked'
                            })(
                                <Checkbox disabled={this.props.restrictProjectFields || !this.props.companyAllowCii}><span>{t("TI Tax relief?")}</span></Checkbox>
                            )}

                        </FormItem>
                    </Col>
                </Row>
            }

            {
                this.props.firstTaskOptional &&
                < Row gutter={24}>
                    <Col span={8}>
                    <FormItem>
                            <Checkbox onClick={() => this.setState({ addFirstTask: !this.state.addFirstTask })} disabled={this.props.restrictProjectFields}><span>{t("Add first task")}</span></Checkbox>
                    </FormItem>
                </Col>
                    {
                        this.props.companyAllowCir &&
                        <Col span={8}>
                            <FormItem>
                                {this.props.getFieldDecorator(nameof<NewProjectItem>('rdTaxRelief'), {
                                    rules: [], initialValue: item.rdTaxRelief, valuePropName: 'checked'
                                })(
                                    <Checkbox disabled={this.props.restrictProjectFields || !this.props.companyAllowCir}><span>{t("R&D Tax relief?")}</span></Checkbox>
                                )}

                            </FormItem>
                        </Col>
                    }
                    {
                        this.props.companyAllowCii &&
                        <Col span={8}>
                            <FormItem>
                                {this.props.getFieldDecorator(nameof<NewProjectItem>('tiTaxRelief'), {
                                    rules: [], initialValue: item.tiTaxRelief, valuePropName: 'checked'
                                })(
                                    <Checkbox disabled={this.props.restrictProjectFields || !this.props.companyAllowCii}><span>{t("TI Tax relief?")}</span></Checkbox>
                                )}

                            </FormItem>
                        </Col>
                    }
                </Row>
            }
            
            <Row gutter={24}>
                <Col span={12}>
                    <FormItem label={(
                        <EditableTooltip
                            name='new-project-dates'
                            visible={this.state.isSelectingDate === undefined ? undefined : !this.state.isSelectingDate}>
                            {t("Start date")}
                        </EditableTooltip>
                    )}>
                        {this.props.getFieldDecorator(nameof<NewProjectItem>('fromDate'), {
                            rules: [{ required: false, message: t('Start date required') }],
                        })(
                            <DatePicker
                                onOpenChange={this.onOpenCalendar}
                                onChange={this.onSelectStartDate}
                                disabledDate={this.disabledStartDate}
                                disabled={this.props.restrictProjectFields}/>
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem label={(
                        <EditableTooltip
                            name='new-project-dates'
                            visible={this.state.isSelectingDate === undefined ? undefined : !this.state.isSelectingDate}
                        >
                            { t("End date")}
                        </EditableTooltip>
                    )}>
                        {this.props.getFieldDecorator(nameof<NewProjectItem>('toDate'), {
                            rules: [{ required: false, message: t('End date required') }, { validator: this.validateEndDate }],
                        })(
                            <DatePicker
                                onOpenChange={this.onOpenCalendar}
                                onChange={this.onSelectEndDate}
                                disabledDate={this.disabledEndDate}
                                value={this.state.endDate}
                                disabled={this.props.restrictProjectFields}/>
                        )}
                    </FormItem>
                </Col>
                </Row>
        </Form>
    }
}

@connect(["newProject", NewProjectStore])
class NewProjectView extends React.Component<NewProjectViewProps & WithTranslation & FormComponentProps, NewProjectViewState> {
    private get newProjectStore() {
        return (this.props as any).newProject as NewProjectStore;
    }

    constructor(props: NewProjectViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.state = {
            restrictProjectFields: false,
            isBusy: false
        }
        this.newProjectStore.createNew({} as any);
        this.newProjectStore.changeUrl(props.companyId);
    }

    componentWillReceiveProps(nextProps: NewProjectViewProps) {
        if (this.newProjectStore.state.result && this.newProjectStore.state.result.isSuccess)
            this.props.onClose((this.newProjectStore.state.result as any).aggregateRootId, this.newProjectStore.state.item)
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private onCreateNewItem() {
        var self = this;
        const { t } = this.props;
        return new Promise((resolve, reject) => {
            self.props.form.validateFields(async event => {
                var values = self.props.form.getFieldsValue();
                var { fromDate, toDate } = values

                //format Start date to correct unix value
                if (fromDate) {
                    values = { ...values, fromDate: values.fromDate.unix() }
                } else {
                    fromDate = moment().utc().startOf("day").unix()
                    values = { ...values, fromDate: fromDate }
                }

                //format End date to correct unix value if provided
                if (toDate) {
                    values = { ...values, toDate: values.toDate.unix() }
                }

                if (!event) {
                    values = {
                        ...values,
                        companyId: this.props.companyId,
                        ignoreProjectCreation: this.state.restrictProjectFields
                    };

                    var projectItem = values as ProjectItem;
                    projectItem.id = this.props.dataProject.id;
                    projectItem.approved = true;

                    this.setState({ isBusy: false });
                    var update = await this.newProjectStore.update(projectItem).then(() => this.countDownNotification(notification.success, t("Notification"), t("All changes were successfully saved"), "succes")).catch(error => { this.countDownNotification(notification.error, t("Error"), t("There was an error saving changes"), "error") }) //eturn this.projectsStore.update(Object.assign(clone(this.projectsStore.state.item), unzipedValues)).then(() => this.countDownNotification(notification.success, t("Notification"), t("All changes were successfully saved"), "succes")).catch(error => { this.countDownNotification(notification.error, t("Error"), t("There was an error saving changes"), "error") });

                    this.newProjectStore.clear();
                    this.props.onClose(undefined);
                    this.setState({ isBusy: false });

                    if (this.props.onRefresh) {
                        this.props.onRefresh();
                    }
                }
            });
        })
    }

    @autobind
    private onCancelNewItem() {
        this.newProjectStore.clear();
        this.props.onClose(undefined);
    }

    public render() {
        const { getFieldDecorator } = this.props.form;
        const { t } = this.props;
        return (
            <Modal
                maskClosable={false}
                visible
                onCancel={this.onCancelNewItem}
                onOk={this.onCreateNewItem}
                closable={false}
                width='800px'
                okText={t("OK")}
                cancelText={t("Cancel")}
                title={t("New project")}>
                {this.newProjectStore.state.result && !this.newProjectStore.state.result.isSuccess &&
                    <Alert type='error'
                        message={t("Error")}
                        description={t(formatMessage(this.newProjectStore.state.result))}
                    />
                }
                <Spin spinning={this.state.isBusy}>
                    <ProjectFormBody
                        i18n={this.props.i18n}
                        t={this.props.t}
                        tReady={this.props.tReady}
                        getFieldDecorator={getFieldDecorator}
                        onSave={this.onCreateNewItem}
                        item={this.props.dataProject}
                        firstTaskOptional={this.props.firstTaskOptional}
                        restrictProjectFields={this.state.restrictProjectFields}
                        companyAllowCir={this.props.companyAllowCir}
                        companyAllowCii={this.props.companyAllowCii} />
                </Spin>
            </Modal>
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(NewProjectView as any) as any) as any as React.ComponentClass<NewProjectViewProps>;